import { call, put, takeLatest } from "redux-saga/effects";

import { PayloadAction } from "@reduxjs/toolkit";
import { message } from "antd";
import api from "service/apiService";
import { ApiResponse } from "types";
import { translate } from "utils";
import { Brand } from "../types";
import {
	getBrandsAsync,
	getBrandDetailsAsync,
	GetBrandsAsyncPayload,
	GetBrandDetailsPayload,
	setBrands,
	CreateBrandPayload,
	createNewBrandAsync,
	setBrand,
	updateBrandAsync,
	UpdateBrandPayload,
} from "./brand.slice";

// Get list
function* getBrandsSaga(action: PayloadAction<GetBrandsAsyncPayload>) {
	const { query, callback } = action.payload;
	const { response, error } = yield call(async () => {
		try {
			const { data: response } = await api.get<ApiResponse<Brand[]>>(
				"/dashboard-brands",
				{ ...query, skip: query.skip },
			);
			return { response };
		} catch (error) {
			return { error };
		}
	});
	if (response) {
		callback && callback();
		yield put({ type: setBrands.type, payload: response });
	} else {
		message.error(translate(error.message));
	}
}

function* watchGetBrands() {
	yield takeLatest(getBrandsAsync, getBrandsSaga);
}

// Get brand details
function* getBrandDetailsSaga(action: PayloadAction<GetBrandDetailsPayload>) {
	const { id } = action.payload;
	const { response, error } = yield call(async () => {
		try {
			const { data: response } = await api.get<ApiResponse<Brand>>(
				`/dashboard-brands/${id}`,
			);
			return { response };
		} catch (error) {
			return { error };
		}
	});
	if (response) {
		yield put({ type: setBrand.type, payload: response.data });
	} else {
		message.error(translate(error.message));
	}
}

function* watchBrandDetails() {
	yield takeLatest(getBrandDetailsAsync, getBrandDetailsSaga);
}

// Create new brand
function* createNewBrandSaga(action: PayloadAction<CreateBrandPayload>) {
	const { data, callback } = action.payload;

	const { response, error } = yield call(async () => {
		try {
			const { data: response } = await api.post("/dashboard-brands", data);
			return { response };
		} catch (error) {
			return { error };
		}
	});
	if (response) {
		message.success(translate("Create successful"));
		callback();
	} else {
		message.error(translate(error.message));
	}
}

function* watchCreateBrand() {
	yield takeLatest(createNewBrandAsync, createNewBrandSaga);
}
// Create new brand
function* updateBrandSaga(action: PayloadAction<UpdateBrandPayload>) {
	const { data, id, callback } = action.payload;

	const { response, error } = yield call(async () => {
		try {
			const { data: response } = await api.patch(
				`/dashboard-brands/${id}`,
				data,
			);
			return { response };
		} catch (error) {
			return { error };
		}
	});
	if (response) {
		callback && callback();
		message.success(translate("Update successful"));
	} else {
		message.error(translate(error.message));
	}
}

function* watchUpdateBrand() {
	yield takeLatest(updateBrandAsync, updateBrandSaga);
}

const brandSaga = [
	watchGetBrands(),
	watchBrandDetails(),
	watchCreateBrand(),
	watchUpdateBrand(),
];
export default brandSaga;
